import { Box } from "@mui/material"
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';

const generateRuleTypeColor = (label) => {
    switch (label) {
        case 'budget':
            return { color: '#CC6645', bgColor: '#FFF9F4' };
        case 'status':
            return { color: '#368D69', bgColor: '#F4FFFC' };
        case 'bid':
            return { color: '#5196C8', bgColor: '#F4FCFF' };
        case 'placement':
            return { color: '#5C61D4', bgColor: '#F0F3FF' };
        case 'searchterm':
            return { color: '#7F5EDB', bgColor: '#F3EFFF' };
        // case 'SearchTerm':
        //     return { color: '#B35EDB', bgColor: '#FBEFFF' };
        default:
            return { color: '#B35EDB', bgColor: '#FBEFFF' };
    }
};

const generateGetUserColor = (role) => {

    switch (role) {
        case 'admin':
            return { color: '#CC6645', bgColor: '#FFF9F4' };
        case 'manager':
            return { color: '#368D69', bgColor: '#F4FFFC' };
        case 'executive':
            return { color: '#5196C8', bgColor: '#F4FCFF' };
        case 'agency':
            return { color: '#5C61D4', bgColor: '#F0F3FF' };
        default:
            return { color: '#B35EDB', bgColor: '#FBEFFF' };
    }

}

export const RuleTypeBadge = ({ label, removeVerPadding = false }) => {
    const generatedColor = generateRuleTypeColor(label?.toLowerCase());

    return (
        <Box px={1} py={removeVerPadding ? 0 : 0.5} display={'inline-flex'} alignItems={'center'} gap={0.5} justifyContent={'center'}
            sx={{ border: `.5px solid ${generatedColor.color}`, backgroundColor: `${generatedColor.bgColor}`, borderRadius: '40px' }}>
            <div style={{ height: '6px', width: '6px', backgroundColor: `${generatedColor.color}`, borderRadius: '6px' }} />
            <span style={{ color: `${generatedColor.color}`, fontSize: '10px', fontWeight: 400, fontFamily: "'Open Sans', sans-serif" }}>{label?.charAt(0).toUpperCase() + label?.slice(1)}</span>
        </Box>
    );
};

export const getUserBadge = (role, fontCustomStye = '', active) => {
    const generatedColor = generateGetUserColor(role.toLowerCase());

    const isActiveMode = !!active;
    const isSelected = role === active;

    return (
        <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            border={`1px solid ${generatedColor.color}`}
            borderRadius="15px"
            bgcolor={generatedColor.bgColor}
            p={'4px 10px'}
        >
            {isActiveMode && isSelected ? <span className="mr-1"><RadioButtonCheckedIcon sx={{ fontSize: '16px', color: generatedColor.color }} /></span> : null}
            <span className={fontCustomStye} style={{ color: generatedColor.color }}>
                {role}
            </span>
        </Box>
    );
};